import {z} from 'zod';

export const carPassCredentialsSchema = z.object({
  username: z.string(),
  password: z.string(),
  enteredOrganisation: z.string(),
  enterpriseOrganisation: z.string(),
});
export type CarPassCredentials = z.infer<typeof carPassCredentialsSchema>;

export const carPassConfigResponseBodySchema = z.object({
  enabled: z.boolean(),
  credentials: carPassCredentialsSchema.nullable(),
});
export type CarPassConfigResponseBody = z.infer<typeof carPassConfigResponseBodySchema>;

export const carPassConfigRequestBodySchema = z.object({
  enabled: z.boolean().nullable().optional(),
  credentials: carPassCredentialsSchema.nullable().optional(),
});
export type CarPassConfigRequestBody = z.infer<typeof carPassConfigRequestBodySchema>;

export const patchCarPassConfigRequestBodySchema = carPassConfigRequestBodySchema;
export type PatchCarPassConfigRequestBody = z.infer<typeof patchCarPassConfigRequestBodySchema>;

export const getCarPassConfigApiArgSchema = z.object({
  branchId: z.string(),
});
export type GetCarPassConfigApiArg = z.infer<typeof getCarPassConfigApiArgSchema>;

export const patchCarPassConfigApiArgSchema = z.object({
  branchId: z.string(),
  patchCarPassConfigRequestBody: patchCarPassConfigRequestBodySchema,
});
export type PatchCarPassConfigApiArg = z.infer<typeof patchCarPassConfigApiArgSchema>;

export const deleteCarPassConfigApiArgSchema = z.object({
  branchId: z.string(),
});
export type DeleteCarPassConfigApiArg = z.infer<typeof deleteCarPassConfigApiArgSchema>;

export type GetCarPassConfigApiResponse = z.infer<typeof carPassConfigResponseBodySchema>;
export type PatchCarPassConfigApiResponse = void; // 204
export type DeleteCarPassConfigApiResponse = void; // 204
